import React, { useState, useEffect } from "react";
import { Input, Spin, Table } from "antd";
import "./../lists_cars/carlist.scss";
import { GoVerified } from "react-icons/go";
import { FiSearch } from "react-icons/fi";
import { FaTags } from "react-icons/fa";
import { RiEye2Line, RiDeleteBin2Fill, RiEdit2Fill } from "react-icons/ri";
import {
  deleteVideo,
  fetchVideos,
} from "../stores/api_calls/discover-videos";
import moment from "moment";
import CustomDeleteModal from "../custom_components/customDeleteModal";
import { IconButton } from "../custom_components/customButton";
import { createSearchParams, useNavigate } from "react-router-dom";
import Kjur from "../stores/utils/jwt";
import CustomVideoView from "../custom_components/customVideoView";
import { error, success } from "../contants/snackbars";

const UnverifiedVideoList = () => {
    
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState([]);
  const [keywordSearch, setKeywordSearch] = useState("");
  const [showModal, setShowModal] = useState({
    showDelete: false,
    showPreview: false,
    showAsSold: false,
    data: {},
  });
  const [tablePagination, setTablePagination] = useState({
    current: 1,
    pageSize: 10,
    total: "",
    defaultPageSize: 10,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `Total ${total} items`,
    pageSizeOptions: ["10", "20", "30"],
  });
  const columns = [
    {
      title: "Date Created",
      dataIndex: "dateCreated",
      render: (text, record) =>
        moment.utc(record.date_created).local().format("YYYY-MM-DD HH:mm:ss"),
      width: '105px',
    },
    {
      title: "Date Updated",
      dataIndex: "dateUpdated",
      render: (text, record) =>
        moment.utc(record.date_updated).local().format("YYYY-MM-DD HH:mm:ss"),
      width: '105px',
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (text, record) => `${record.title}`,
      width: '150px',
    },
    {
      title: "Video Type",
      dataIndex: "videoType",
      render: (text, record) => `${record.video_type}`,
    },
    {
      title: "Video Duration",
      dataIndex: "videoDuration",
      render: (text, record) =>
        `${record?.video_duration}`,
    },
    {
      title: "Created by",
      dataIndex: "createdBy",
      render: (text, record) => `${record?.advertisement_contact_details?.name ?? '-'}`,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="actions-icons-container">
          <IconButton
            className="icon-button view"
            tootTipTitle="View Video"
            Icon={<RiEye2Line />}
            onClick={() => onPreviewVideo(record)}
          />
          <IconButton
            className="icon-button edit"
            tootTipTitle="Edit Video"
            Icon={<RiEdit2Fill />}
            onClick={() => onEdit(record)}
          />
          <IconButton
            className="icon-button delete"
            tootTipTitle="Delete Video"
            Icon={<RiDeleteBin2Fill />}
            onClick={() => onDelete(record)}
          />
        </div>
      ),
      width: '150px',
    },
  ];

  useEffect(() => {
    refetchLists();
  }, []);

  useEffect(() => {
    if (tablePagination.current || tablePagination.pageSize) {
      refetchLists();
    }
  }, [tablePagination.current, tablePagination.pageSize]);

  const refetchLists = () => {
    const pagination = {
      page: tablePagination.current,
      limit: tablePagination.pageSize,
      keyword: keywordSearch,
    };

    fetchData(pagination);
  };

  const fetchData = (data) => {
    setIsLoading(true);

    const verifiedCars = fetchVideos({...data, status: "processing"});

    verifiedCars
      .then((res) => {
        if (res.data.success) {
          setTableData(res.data.data);
          setTablePagination({
            ...tablePagination,
            total: res.data.meta.pagination.total,
          });
          setIsLoading(false);
        }
      })
      .catch((e) => {
        error(
          `Opps! ${e.response.data.server_response} . Fetched Failed. Please try again later`
        );
      });
  };

  const onEnter = (e) => {
    if (e.key === "Enter") {
      const pagination = {
        page: 1,
        limit: 10,
        keyword: keywordSearch,
      };
      fetchData(pagination);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTablePagination(pagination);
  };

  const onEdit = (record) => {
      
      navigate(
        {
          pathname: "../discover-videos/edit",
          search: `?${createSearchParams({ id: record.id })}`,
        },
        { replace: true }
      );
  }

  const onDelete = (record) => {
    setShowModal({ ...showModal, showDelete: true, data: record });
  };

  const onDeleteSubmit = () => {
    const filteredData = tableData.filter(
      (el) => el.id !== showModal.data.id
    );

    const onDelete = deleteVideo(showModal.data.id);
    onDelete
      .then((res) => {
        if (res.data.success) {
          setTableData(filteredData);
          setShowModal({ ...showModal, showDelete: false, data: {} });
          success("Video Deleted Successfully");
        }
      })
      .catch((e) => {
        error(e.response.data.server_response);
      });
  };

  const onPreviewVideo = (record) => {
    setShowModal({ ...showModal, showPreview: true, data: record });
  };

  return (
    <div className="table-container">
        <div className="table-container-inner">
          <div className="table-title-icon verified">
            <GoVerified />
          </div>
          <p className="table-title-text verified">Unverified Discover Video List</p>

          <div className="search-container">
            <Input
              size="large"
              style={{ width: 300 }}
              placeholder="Search Record"
              prefix={<FiSearch />}
              onChange={(e) => setKeywordSearch(e.target.value)}
              onKeyPress={onEnter}
            />
          </div>

          <div className='scrollable-table-container'>
            <Table
              columns={columns}
              rowKey={(record) => record._id}
              dataSource={tableData}
              pagination={tablePagination}
              loading={{ indicator: <Spin size="large" />, spinning: isLoading }}
              onChange={handleTableChange}
              bordered
              sticky
            />
          </div>

          <CustomVideoView
            title="Video View"
            visible={showModal.showPreview}
            data={showModal.data}
            onCancel={() =>
              setShowModal({ ...showModal, showPreview: false, data: {} })
            }
          />

          <CustomDeleteModal
            title="Delete Discover Video"
            visible={showModal.showDelete}
            onSubmit={onDeleteSubmit}
            onCancel={() =>
              setShowModal({ ...showModal, showDelete: false, data: {} })
            }
            data={{ itemName: `${showModal.data.title}`, type: "video" }}
          />
        </div>
    </div>
  );
};

export default UnverifiedVideoList;